<template>
    <div class="cc-4-l widget-simple-text">

        <!-- If loading -->
        <div class="cc-loader" v-if="loading">
            <div class="spinner"></div>
        </div>
        <div v-else>
            <span class="cc-block cc-fs-50">{{ currentDate }}</span>
            <span class="cc-block cc-fs-75 cc-fw-700">{{ currentHours }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Clock',
        data() {
            return {
                loading: true,
                currentTime: new Date(),
                currentHours : null,
                currentDate: null
            }
        },
        methods: {
            updateCurrentTime() {
                this.currentTime = new Date()
                this.currentHours = this.currentTime.toLocaleTimeString()
                this.currentDate = this.currentTime.toLocaleDateString()
            }
        },
        mounted() {
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
            this.loading = false

        }
    }
</script>


<style lang="less">
    .widget-simple-text {
        background-color: #333;
        font-size: 4em;
        align-items: center;
        justify-content: center;
    }
</style>
